<template>
    <div id="app" class="frut-45-light">
            <Home />
    </div>
</template>

<script>
    import Home from './components/Home.vue';

    export default {
        name: 'app',
        components: {
            Home
        }
    };
</script>

<style>

    .d-flex {
        display: -ms-flexbox !important;
        display: flex !important;
    }
</style>

